module.exports = __webpack_public_path__ + "img/mm-dual-logos.3aeaac39.png";